export var EMPTY_ARRAY = Object.freeze([]);
export var EMPTY_OBJECT = Object.freeze({});
//# sourceMappingURL=empties.js.map